import React from 'react';
import { ChevronRight } from 'lucide-react';
import CrisisSupport from './CrisisSupport';
import { useTheme } from '../../hooks/useTheme';

const Resources = () => {
  const { theme } = useTheme();

  const resources = [
    {
      category: 'Crisis Support',
      icon: '🆘',
      items: [
        { name: '988 Suicide & Crisis Lifeline', action: 'Call 988', link: 'tel:988' },
        { name: 'Crisis Text Line', action: 'Text HOME to 741741', link: 'sms:741741' },
        { name: 'Campus Counseling', action: 'Schedule Appointment', link: '#' }
      ]
    },
    {
      category: 'Self-Help Resources',
      icon: '📚',
      items: [
        { name: 'Breathing Exercises', action: 'Start Exercise', link: '#' },
        { name: 'Meditation Guide', action: 'Begin Session', link: '#' },
        { name: 'Stress Management Tips', action: 'Read More', link: '#' }
      ]
    },
    {
      category: 'Academic Support',
      icon: '🎓',
      items: [
        { name: 'Study Skills Center', action: 'Book Session', link: '#' },
        { name: 'Writing Center', action: 'Schedule Review', link: '#' },
        { name: 'Academic Advising', action: 'Make Appointment', link: '#' }
      ]
    },
    {
      category: 'Financial Wellness',
      icon: '💰',
      items: [
        { name: 'Financial Aid Office', action: 'Contact', link: '#' },
        { name: 'Emergency Funds', action: 'Apply', link: '#' },
        { name: 'Budget Calculator', action: 'Open Tool', link: '#' }
      ]
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Resources</h1>
        <p className="text-gray-600">Support services and self-help tools</p>
      </div>

      <CrisisSupport />

      {/* Resource Categories */}
      {resources.map(category => (
        <div key={category.category} className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
          <div className="flex items-center space-x-3 mb-4">
            <span className="text-2xl">{category.icon}</span>
            <h3 className="font-semibold text-lg">{category.category}</h3>
          </div>
          
          <div className="space-y-3">
            {category.items.map(item => (
              <div 
                key={item.name}
                className={`flex items-center justify-between p-4 rounded-lg ${
                  theme === 'dark' ? 'bg-gray-700' : 'bg-gray-50'
                } hover:bg-opacity-80 transition-colors`}
              >
                <div>
                  <h4 className="font-medium">{item.name}</h4>
                </div>
                <a
                  href={item.link}
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 font-medium"
                >
                  <span>{item.action}</span>
                  <ChevronRight className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Self-Care Tips */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold text-lg mb-4">Quick Self-Care Tips</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { icon: '💧', title: 'Stay Hydrated', desc: 'Drink 8 glasses of water daily' },
            { icon: '🏃', title: 'Move Your Body', desc: '30 minutes of activity daily' },
            { icon: '😴', title: 'Prioritize Sleep', desc: 'Aim for 7-9 hours nightly' },
            { icon: '🧘', title: 'Practice Mindfulness', desc: '5 minutes of deep breathing' }
          ].map(tip => (
            <div key={tip.title} className="flex items-start space-x-3">
              <div className={`w-8 h-8 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-100'} rounded-full flex items-center justify-center flex-shrink-0`}>
                <span>{tip.icon}</span>
              </div>
              <div>
                <h4 className="font-medium">{tip.title}</h4>
                <p className="text-sm text-gray-600">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;